import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/index'
import store from '@/store/index'
import Vuex from 'vuex'
import '@/plugins/index'
import CountryFlag from 'vue-country-flag'
// import VTiptap from "@peepi/vuetify-tiptap";
import VueTelInput from 'vue-tel-input'
import money from 'v-money'
import vClickOutside from 'v-click-outside'
import VTooltip from 'v-tooltip'
import Common from '@/services/Settings'
import helpers from '@/helpers'
import '@fortawesome/fontawesome-free/css/all.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import {TiptapVuetifyPlugin} from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'

Vue.component('vue-country-flag', CountryFlag)

export const eventBus = new Vue()

const plugin = {
  install() {
    Vue.helpers = helpers
    Vue.prototype.$helpers = helpers
  }
}

Vue.use(plugin)
Vue.use(vClickOutside)
Vue.use(VueTelInput)
Vue.use(money, {decimal: ',', thousands: '.', prefix: '$ ', precision: 2})
Vue.use(Vuex)
Vue.use(VTooltip)
// Vue.use(VTiptap);
Vue.use(TiptapVuetifyPlugin, {
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'md'
})
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
    language: 'en',
  }
});
Vue.config.productionTip = false

Vue.prototype.$legacy = process.env.VUE_APP_LEGACY_SITE
Vue.prototype.$cookieDomainName = process.env.VUE_APP_COOKIE_DOMAIN_NAME
Vue.prototype.$cookieName = process.env.VUE_APP_COOKIE_NAME

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.$store.commit('clearError')
    this.$store.commit('setLoading', true)

    if (localStorage.getItem('access_token') || localStorage.getItem('refresh_token')) {
      this.axios.get(this.$apiRouter.me)
        .then(response => {
          if (response.status === this.$response.Ok) {
            this.$store.dispatch('createNewUser', response.data.data.user)
          }
        })
        .then(() => {
          this.$store.commit('setLoading', true)
          Common.getSettings()
            .then(response => {
              if (response.status === this.$response.Ok) {
                this.$store.dispatch('setSettings', response.data.data)
              }
            })
            .catch(error => {
              this.$store.commit('setError', error.data)
            })
            .finally(() => {
              this.$store.commit('setLoading', false)
            })
        })
        .catch(error => {
          if (error.response && error.response.data && error.response.data.message) {
            this.$store.dispatch('setError', error.response.data.message)
          }
        })
        .finally(() => {
          this.$store.commit('setLoading', false)
        })
    }
    this.$store.commit('setLoading', false)
  },
}).$mount('#app')
